export default __webpack_public_path__ + "images/online-payment/visa.svg?ee8664d8a7ea287ee641fbbba8f3efe47ac74592345356df478cfb09662e5469";